import {
    Vector3,
    Matrix3,
    Matrix4
} from 'three'

//

export class FollowPath {

    #_duos = []
    #_n0 = new Vector3(0, 1, 0) // Normal, first up

    constructor() {
        //
    }

    add(curve, object, velocity) {

        const v = {
            t: undefined,
            n: new Vector3(), // Normal
            b: new Vector3(), // Binormal
            m3: new Matrix3(),
            m4: new Matrix4(),
            f: 0,
            p: new Vector3(),
            curve,
            object,
            velocity
        }

        this.#_duos.push(v)
    }

    /*
    // let t
    // const n0 = new THREE.Vector3(0, 1, 0) // Normal, first up
    // const n = new THREE.Vector3() // Normal
    // const b = new THREE.Vector3() // Binormal
    // const m3 = new THREE.Matrix3()
    // const m4 = new THREE.Matrix4()
    // let f = 0
    // let p = new THREE.Vector3()

    // function followPath(curve, object) {

    //     if( f === 0 || f > 1) {
    //         n.copy( n0 )
    //         f = 0
    //     }

    //     f += 0.0003 // "Velocity"

    //     t = curve.getTangent( f )
    //     b.crossVectors(t, n)
    //     n.crossVectors(t, b.negate() )

    //     m3.set( -t.x, n.x, b.x,  -t.y, n.y, b.y,  -t.z, n.z, b.z )
    //     m4.setFromMatrix3( m3 )

    //     p = curve.getPoint( f )

    //     object.setRotationFromMatrix( m4 )
    //     object.position.set( p.x, p.y, p.z )
    // }
    */

    #_follow(obj) {

        if( obj.f === 0 || obj.f > 1) {
            obj.n.copy( this.#_n0 )
            obj.f = 0
        }

        obj.f += obj.velocity/10000  // 0.0003 // "Velocity"

        obj.t = obj.curve.getTangent( obj.f )
        obj.b.crossVectors( obj.t, obj.n )
        obj.n.crossVectors( obj.t, obj.b.negate() )

        obj.m3.set(
            -obj.t.x, obj.n.x, obj.b.x,
            -obj.t.y, obj.n.y, obj.b.y,
            -obj.t.z, obj.n.z, obj.b.z
        )
        obj.m4.setFromMatrix3( obj.m3 )

        obj.p = obj.curve.getPoint( obj.f )

        obj.object.setRotationFromMatrix( obj.m4 )
        obj.object.position.set( obj.p.x, obj.p.y, obj.p.z )

    }

    update() {
        for (let i = 0; i < this.#_duos.length; i++) {
            this.#_follow( this.#_duos[i] )
        }
    }

}